import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import {RootState} from '@/store/type';
import {LoginInfo} from '@/store/auth/auth.types';
import {MainMutation} from '@/store/mutation';
import {MainGetters} from '@/store/getters';
import {authState} from '@/store/auth/auth.index';
import {loadingState} from '@/store/loading/loading.index';
import {branchState} from '@/store/branch/branch.index';
import {memberState} from '@/store/member/member.index';
import {communityState} from '@/store/community/community.index';
import {subServiceState} from '@/store/subservice/subservice.index';
import {serviceState} from '@/store/service/service.index';
import {toastState} from '@/store/toast/toast.index';
import {filesState} from '@/store/files/files.index';
import {serviceTransactionState} from '@/store/service-transaction/service-transaction.index';
import {eventState} from '@/store/event/event.index';
import {handleState} from '@/store/handleResponse';
import {addressState} from '@/store/address/address.index';
import {timeTransactionState} from '@/store/time-transaction/time-transaction.index';


// %%auto_add_router_path%%
Vue.use(Vuex);
const store: StoreOptions<RootState> = {
  state: {
    version: '0.0.1',
    userInfo: {} as LoginInfo,
    loading: false
  },
  modules: {
    auth: authState,
    loading: loadingState,
    branch: branchState,
    member: memberState,
    community: communityState,
    service: serviceState,
    subService: subServiceState,
    toast: toastState,
    file: filesState,
    serviceTransaction: serviceTransactionState,
    handle: handleState,
    event: eventState,
    address: addressState,
    timeTransaction: timeTransactionState
// %%auto_import_model_router%%
  },
  getters: MainGetters,
  mutations: MainMutation
};
export default new Vuex.Store<RootState>(store);
